import style from "../styles/header.css";
import logo from "../assets/images/Xpert Logo.png";



export default function header() {
  return (
    <>
      <header>
        <div className="top-bar">
          <div className="header-elements">
            {/* <!-- الشعار --> */}
            <div className="logo" >
             <img src={logo} alt="شعار الشركة" />

            </div>

            {/* <!-- القائمة في المنتصف - ستختفي في الهواتف --> */}
            <nav id="mainNav">
              <a href="#about" class="nav-link" data-i18n="aboutUs">
                <i class="fas fa-info-circle"></i>{" "}
                <span data-i18n="aboutUs">من نحن</span>
              </a>
              <a href="#services" class="nav-link" data-i18n="ourServices">
                <i class="fas fa-cogs"></i>{" "}
                <span data-i18n="ourServices">خدماتنا</span>
              </a>
              <a href="#locations" class="nav-link" data-i18n="ourLocations">
                <i class="fas fa-map-marker-alt"></i>{" "}
                <span data-i18n="ourLocations">مواقعنا</span>
              </a>
              <a href="#features" class="nav-link" data-i18n="ourFeatures">
                <i class="fas fa-star"></i>{" "}
                <span data-i18n="ourFeatures">مميزاتنا</span>
              </a>
              <a href="#partners" class="nav-link" data-i18n="ourPartners">
                <i class="fas fa-handshake"></i>{" "}
                <span data-i18n="ourPartners">شركاؤنا</span>
              </a>
              <a href="#contact" class="nav-link" data-i18n="contactUs">
                <i class="fas fa-envelope"></i>{" "}
                <span data-i18n="contactUs">تواصل معنا</span>
              </a>
            </nav>

            {/* <!-- حاوية زر القائمة --> */}
            <div class="mobile-menu-container">
              {/* <!-- أيقونة القائمة للموبايل --> */}
              <button class="mobile-menu-button" id="mobileMenuButton">
                <i class="fas fa-bars"></i>
              </button>

              {/* <!-- القائمة المنسدلة للموبايل - تظهر عند النقر على زر القائمة --> */}
              <div class="mobile-nav" id="mobileNav">
                <a href="#about">
                  <i class="fas fa-info-circle"></i>{" "}
                  <span data-i18n="aboutUs">من نحن</span>
                </a>
                <a href="#services">
                  <i class="fas fa-cogs"></i>{" "}
                  <span data-i18n="ourServices">خدماتنا</span>
                </a>
                <a href="#locations">
                  <i class="fas fa-map-marker-alt"></i>{" "}
                  <span data-i18n="ourLocations">مواقعنا</span>
                </a>
                <a href="#features">
                  <i class="fas fa-star"></i>{" "}
                  <span data-i18n="ourFeatures">مميزاتنا</span>
                </a>
                <a href="#partners">
                  <i class="fas fa-handshake"></i>{" "}
                  <span data-i18n="ourPartners">شركاؤنا</span>
                </a>
                <a href="#contact">
                  <i class="fas fa-envelope"></i>{" "}
                  <span data-i18n="contactUs">تواصل معنا</span>
                </a>
              </div>
            </div>

            {/* <!-- حاوية زر تغيير اللغة --> */}
            <div class="language-container">
              {/* <!-- زر تغيير اللغة --> */}
              <div
                class="language-switcher"
                id="languageSwitcher"
                data-i18n="switchLanguage"
              >
                English
              </div>
            </div>
          </div>
        </div>
        </header>
     
    </>
  );
}
